import React from 'react';
import { Fade } from '@mui/material';
import Spinner from '@mui/material/CircularProgress';

function Loader() {
  return (
    <Fade in timeout={{ exit: 1000 }}>
      <Spinner
        style={{
          position: 'absolute',
          height: '100px',
          width: '100px',
          top: '50%',
          left: '50%',
        }}
        size={250}
      />
    </Fade>
  );
}

export default Loader;
